const COMPACT_FORMATTER = new Intl.NumberFormat('en', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/**
 * Humanize a count for display in compact UI surfaces.
 *
 *   42      → "42"
 *   999     → "999"
 *   1_000   → "1k"
 *   1_234   → "1.2k"
 *   12_345  → "12k"
 *   1_2e6   → "1.2m"
 */
export function formatCompactNumber(n: number): string {
  if (!Number.isFinite(n)) return String(n);
  if (Math.abs(n) < 1000) return String(n);
  return COMPACT_FORMATTER.format(n).toLowerCase();
}
